import 'amfe-flexible';
import './styles/index.less'
import './assets/iconfont/iconfont.js'
import { Swipe, SwipeItem } from 'vant';

import Vue from 'vue';
import Vant from 'vant';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {Uploader} from 'vant'
import 'vant/lib/index.css';
import App from './App';
import { router } from './router';
Vue.use(Vant);
Vue.use(Uploader);
Vue.use(Swipe).use(SwipeItem);
Vue.use(ElementUI)
new Vue({
  router,
  el: '#app',
  render: h => h(App)
});
